import { TasksQueueFilterButton } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/components'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { Header, VertSpacerSm } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { ROUTE_UNIT_PROGRAM_TASK_QUEUE } from '@apps-radionet-portal-root/src/config/private-routes'

interface IProps {
  children?: React.ReactNode
}

export const TaskQueueHeader: React.FC<IProps> = ({ children }) => (
  <Header classes='!max-w-[1650px]'>
    <Navbar transparent showBack icons={[]} />
    <Breadcrumbs route={ROUTE_UNIT_PROGRAM_TASK_QUEUE} />
    <div className='flex items-start justify-between'>
      <PageTitle classes='flex items-start gap-[5px]'>
        <span>{ROUTE_UNIT_PROGRAM_TASK_QUEUE.label}</span>
      </PageTitle>
      <div className='flex items-center justify-end gap-[5px]'>
        <TasksQueueFilterButton />
      </div>
    </div>
    {children && (
      <>
        <VertSpacerSm />
        {children}
        <VertSpacerSm />
      </>
    )}
  </Header>
)
